import { toObject } from "../../core/utils";

class DistrictPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return toObject(data);
  }
}

export default DistrictPageTransform;



// WEBPACK FOOTER //
// ./src/pages/district/district.transforms.js